export enum Route {
  MAIN_SCREEN = "main",
  CLIENTS_SCREEN = "clients",
  CLIENT_SCREEN = "client",
  TRANSACTIONS_SCREEN = "transactions",
  NOT_FOUND = "not_found",
}
